import { SxProps, Theme } from '@mui/material';

const textField: SxProps<Theme> = (theme) => ({ backgroundColor: theme.palette.common.white });

const styles = {
  textField,
};

export default styles;
